(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("customPage", {
        templateUrl: "app/customPages/customPageView.html",
        controller: ["pagesResource", "messageService", "$rootScope", "$state", "$scope", "$timeout", "ngMeta", CustomPageCtrl],
        controllerAs: "vm"
    });
    function CustomPageCtrl(pagesResource, messageService, $rootScope, $state, $scope, $timeout, ngMeta) {
        var vm = this;
        vm.dataLoaded = false;
        vm.friendlyUrl = $state.params.friendlyUrl;
        loadPage();
        ///////////////////////////////////
        function loadPage() {
            pagesResource.getCustomPage({ actionParam: vm.friendlyUrl }, function (data) {
                if (!data.hasOwnProperty("content")) {
                    $state.go("main.notFound", {}, { location: false });
                    return;
                }
                ngMeta.setTitle(data.title);
                if (data.description)
                    ngMeta.setTag("description", data.description);
                vm.content = data.content;
                vm.dataLoaded = true;
                vm.hasDisqus = data.hasDisqus;
                $rootScope.$broadcast("prerenderReady");
            }, function (error) {
                messageService.error(error);
            });
        }
        ////Reload the page when site language is changed
        var navBarLanguageChangedCancel = $scope.$on("navBarLanguageChanged", function () {
            $timeout(function () {
                loadPage();
            });
        });
        this.$onDestroy = function () {
            if (navBarLanguageChangedCancel) {
                navBarLanguageChangedCancel();
            }
        };
    }
}());
